import { ReactNode, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { IconScreen } from "../IconScreen";
import { useAccessStore } from "./useAccess";

export const NoAccessScreen = ({ children }: { children?: ReactNode }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { isDenied, message } = useAccessStore((state) => state);

  // Clear the Access Denied message when the location (route) changes
  useEffect(() => {
    useAccessStore.setState({ isDenied: false, message: "" });
  }, [location]);

  // Needs the empty <> for the return to be deemed as valid JSX
  // Return the children if the user has access
  if (!isDenied) return <>{children}</>;

  // Display access denied screen if the user does not have access
  return (
    <IconScreen
      title="Access Denied"
      description={message}
      group="hifiDark"
      appearance="secondary"
      buttonText="Return to Home"
      buttonOnClick={() => navigate("/")}
    />
  );
};
